import React from "react";
import type { User } from "firebase";

import InvalidPage from "../components/InvalidPage";
import FitrahForm from "./FitrahForm";
import { parseURL } from "./utils";
import { states } from "./rules";

interface Props {
  user: User;
}

const Validator = ({ user }: Props) => {
  try {
    const config = parseURL();

    if (config.action !== "pay") {
      return <InvalidPage />;
    }

    if (config.payment_type !== "zakatfitrah") {
      return <InvalidPage />;
    }

    const body = states.getState(config.body);

    if (body.hasAmil() && !body.isAmilOptional()) {
      if (!config.extra_data || !config.extra_data.amil) {
        return <InvalidPage />;
      }
    }

    if (!user.email) {
      return <InvalidPage />;
    }

    return (
      <FitrahForm
        body={config.body}
        state={body}
        payer_email={user.email}
        amil={config.extra_data?.amil}
        kariah={config.extra_data?.kariah}
      />
    );
  } catch (e) {
    console.log(e);
    return <InvalidPage />;
  }
};

export default Validator;
